import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import { DraggableList } from "@domestika-dev/prudencio/dist/molecules/DraggableList";
import { TextForm } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

import { MORE_CONTENT, CONTENT_ITEMS_MENU } from "../config";

export const OrganizeModal = ({ contentItems, isOpen, onClose, onFocusElement, confirmAction }) => {
  const [sortedComponents, setSortedComponents] = useState(contentItems);
  const [saveDisabled, setSaveDisabled] = useState(true);

  const updateContenItems = sortedItems => {
    setSortedComponents(sortedItems);
    setSaveDisabled(false);

    onFocusElement({ id: MORE_CONTENT });
  };

  const handleSort = () => {
    setSaveDisabled(true);

    confirmAction(sortedComponents);
    onFocusElement({ id: CONTENT_ITEMS_MENU });
    onClose();
  };

  return (
    <Modal
      width="auto"
      heigth="auto"
      isOpen={isOpen}
      id="dmstk-organize-modal"
      onModalClose={onClose}
      {...{ "data-label": "project-organize-modal" }}
    >
      <Modal.Title>
        <FormattedMessage id="projects.new.more_content_section.organize.modal_title" />
      </Modal.Title>
      <Modal.Content>
        <DraggableList
          items={contentItems}
          onChange={updateContenItems}
          itemHeight="64"
          itemWidth={["307px", "307px", "375px"]}
          componentType="contentItemThumbnail"
        />
      </Modal.Content>
      <Modal.Actions>
        <Grid gridTemplateColumns="1fr 1fr" gridTemplateRows="1fr" gridColumnGap={3} marginTop={5}>
          <GridItem>
            <Button
              size="medium"
              hollow="secondary"
              action={onClose}
              buttonType="secondary"
              id="cancel-button"
              {...{ "data-label": "project-organize-cancel" }}
            >
              <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="sonar">
                <FormattedMessage id="projects.new.more_content_section.organize.cancel.button" />
              </TextForm>
            </Button>
          </GridItem>
          <GridItem gridColumn={["auto", "2/2"]}>
            <Button
              size="medium"
              disabled={saveDisabled}
              action={handleSort}
              id="accept-button"
              {...{ "data-label": "project-organize-accept" }}
            >
              <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
                <FormattedMessage id="projects.new.more_content_section.organize.save.button" />
              </TextForm>
            </Button>
          </GridItem>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

OrganizeModal.propTypes = {
  contentItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onFocusElement: PropTypes.func,
  confirmAction: PropTypes.func,
};

OrganizeModal.defaultProps = {
  contentItems: [],
  isOpen: false,
  onClose: () => {},
  onFocusElement: () => {},
  confirmAction: () => {},
};

export default OrganizeModal;
